import api from './api';

/**
 * @param {Object} parameters
 * @param {number} parameters.number_of_tokens
 * @param {string} parameters.description
 * @param {string | null} parameters.test_group_id
 * @param {boolean} [parameters.useChinaUrl]
 * @returns {Promise<{
 *  number_of_tokens_generated: number
 *  success: boolean
 *  batch_id: string
 *  description: string
 *  test_group_id: string | null
 * }>}
 * @see http://dev-dyl-website-docs-f1dd5d50.s3-website.eu-west-2.amazonaws.com/#api-Tokens-postTokens
 */
export default async function createTokens(parameters) {
    const { level_id, useChinaUrl = false, ...body } = parameters;
    const { data } = await api.post(`levels/${level_id}/tokens`, body, { useChinaUrl });

    return data;
}